import Ract from 'react'

import { Text } from "@nextui-org/react";

export default ({value, h1, h2, marginTop, centered, marginLeft = 0, heavy = false, tighten = false}) => {
    return (
        <>
            <Text 
                css={{
                    mt: `${marginTop}`,
                    ml: `${marginLeft}`,
                    letterSpacing: tighten ? '$tight' : 0,
                    lineHeight: "$sm",
                    textAlign: centered ? "center" : "left",
                    fontFamily: heavy ? "Garet Heavy" : "Garet",
                    textGradient: "90deg, $brandColor500 -20%, $brandColor900 50%",
                    fontWeight: "bold",
                    fontSize: h1 ? "$2xl" : (h2 ? "$xl" : "$sm"),
                    '@xsMin': {
                        fontSize: h1 ? "$4xl" : (h2 ? "$2xl" : "$xl")
                    },
                    // '@smMin': {
                    //     ml: 0
                    // }
                }}
            >
                {value}
            </Text>
        </>
    )
}